import React, { useContext, useMemo, useRef, useState } from 'react'
// import { strCol, numCol, dateTimeCol } from '@integec/grid-tools/lib/cols'
// import { OaEventIoHeaders } from './../Headers'
import MarginAnalysisContext from 'marginanalysis/MarginAnalysisContext'
// import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import HourlyDetailsData from './HourlyDetailsDataList'
import HourlyDetailsGraph from './HourlyDetailsGraph'
import R from 'ramda'
import { Checkbox, Button, DatePicker, Modal } from 'antd'
import { getUtilityNameMap, getUnitNameMap } from 'core/selectors'
import * as d3 from 'd3'
import ConstantListDialog from './ConstantListDialog'
import { FullHeightSizer } from 'core/screen-util'
import { connect } from 'react-redux'
import { PNodeZoneContext } from 'context'
import { getClientInfo } from 'core'
import { getDataItemByClient } from './HourlyDataItems'
import { getFinalData } from 'marginanalysis/utils'
// import { virtualizedGridRenderer } from '@integec/grid-tools'
// import { strCol } from '@integec/grid-tools/lib/cols'
// import Grid from '@integec/grid-tools/lib/Grid'
// import { toSelectionColProps } from '@integec/grid-tools/lib/utils'

const HourlyDetailsModal = props => {
  const {
    whatIf = false,
    unitNameMap,
    unitId,
    CLIENT,
    isEventPlanner = false,
    trueup = false,
  } = props
  const { emktIdUnitNameMap } = useContext(PNodeZoneContext)
  const {
    showTarget,
    setShowTarget,
    showGenMW,
    setShowGenMW,
    selectedDateRangePicker,
    setScrollValueLeft,
    ...marginContext
  } = useContext(MarginAnalysisContext)

  const [startDate, setStartDate] = useState(selectedDateRangePicker[0].clone())
  const [endDate, setEndDate] = useState(
    selectedDateRangePicker[0].clone().add(3, 'days')
  )
  const [showExplanationDialog, setShowExplanationDialog] = useState(false)

  const showExplanation = _ => setShowExplanationDialog(true)

  const graphDivRef = useRef()
  const graphSvgRef = useRef()
  const gridDataRef = useRef()

  const onScrollDiv = e => {
    const { scrollLeft } = e.target
    setScrollValueLeft(scrollLeft)
    if (gridDataRef.current) {
      gridDataRef.current.scrollToPosition({ scrollLeft })
    }
  }

  const { hourlyDetailsData = [] } = getFinalData(
    marginContext,
    whatIf,
    isEventPlanner,
    trueup
  )

  const dateHeaders = useMemo(
    _ => {
      const dt = startDate.clone().set('hour', 0)
      const ed = endDate
        .clone()
        .set('hour', 0)
        .add(1, 'd')

      const diff = ed.diff(dt, 'HOURS')
      // eslint-disable-next-line no-unused-vars
      return R.range(1, diff + 1).map(d => {
        let dat = dt.clone()
        const dv =
          dat.format('YYYY-MM-DD') + ' ' + (parseInt(dat.format('H')) + 1)
        dat = dt.add(1, 'hour')

        return dv
      })
    },
    [endDate, startDate]
  )

  const data = useMemo(
    _ => {
      const sd = startDate.clone().set('hour', 0)
      const diff = endDate
        .clone()
        .set('hour', 0)
        .add(1, 'd')
        .diff(sd, 'HOURS')
      // eslint-disable-next-line no-unused-vars
      const hourMap = R.range(1, diff + 1).map(i => {
        let dt = sd
        // let r = hourlyDetailsData.find(f => f.unitId === u && f.transDate === dt)
        const z = {
          effectiveDate: dt.format('YYYY-MM-DD'),
          hour: parseInt(dt.format('H')) + 1 + '',
          dx: dt.format('YYYY-MM-DD H'),
          dv: dt.format('YYYY-MM-DD') + ' ' + (parseInt(dt.format('H')) + 1),
        }
        dt = sd.add(1, 'hour')
        return z
      })

      const dataSet = R.compose(
        // R.sortBy(R.compose(R.toLower, R.prop('item'))),
        a => {
          return a.map(e => {
            const mp = hourMap.map(hr => {
              const dd = hourlyDetailsData.find(
                d => d.transdate === hr.effectiveDate && d.hour === hr.hour
              )
              return { item: e, [hr.dv]: dd ? dd[e] : '' }
            })
            return mp && mp.length > 0 && mp.reduce((x, y) => ({ ...x, ...y }))
          })
        },
        R.uniq,
        R.flatten,
        _ => Object.keys(getDataItemByClient(CLIENT, trueup))
      )(hourlyDetailsData)

      return dataSet
    },
    [startDate, endDate, hourlyDetailsData, CLIENT, trueup]
  )

  const columnWidth = 100

  const xScale = useMemo(
    _ => {
      return d3
        .scaleBand()
        .range([0, columnWidth * dateHeaders.length])
        .domain(dateHeaders)
        .paddingOuter(0)
        .align(0)
    },
    [columnWidth, dateHeaders]
  )

  return (
    <Modal
      maskClosable={false}
      title={
        <div style={{ display: 'flex', columnGap: '30px' }}>
          <div>Hourly Details </div>
          {/* <div>- {unitId} - </div> */}
          <div>{unitNameMap['' + unitId] || emktIdUnitNameMap[unitId]} </div>
          <div>
            {selectedDateRangePicker[0].format('MM/DD/YYYY')} -{' '}
            {selectedDateRangePicker[1].format('MM/DD/YYYY')}
          </div>
        </div>
      }
      visible={props.visible}
      onOk={_ => {
        setScrollValueLeft(0)
        props.setClose(false)
      }}
      onCancel={_ => {
        setScrollValueLeft(0)
        props.setClose(false)
      }}
      footer={<div />}
      width="95%"
      height="100%"
      style={{ top: 10, height: '100%' }}
      // bodyStyle={{ height: '600px' }}
      bodyStyle={{ paddingTop: '10px' }}
    >
      {showExplanationDialog && (
        <ConstantListDialog
          visible={showExplanationDialog}
          setClose={_ => setShowExplanationDialog(false)}
          whatIf={whatIf}
          isEventPlanner={isEventPlanner}
        />
      )}
      <FullHeightSizer heightOffset={170}>
        {({ height, width }) => (
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '150px auto',
              gridTemplateRows: 'min-content max-content  max-content',
              gridGap: '5px',
              height,
              width,
            }}
          >
            <div
              style={{
                gridColumn: 'span 2',
                display: 'grid',
                gridTemplateColumns: '150px 150px 250px 200px',
                // gridGap: '5px',
                justifyItems: 'end',
                alignItems: 'center',
              }}
            >
              <div />
              <div>Select Date Range : </div>
              <DatePicker.RangePicker
                allowClear={false}
                style={{ marginLeft: '10px' }}
                defaultValue={[startDate, endDate]}
                value={[startDate, endDate]}
                format="MM/DD/YYYY"
                disabledDate={cur =>
                  cur.isBefore(selectedDateRangePicker[0]) ||
                  cur.isAfter(selectedDateRangePicker[1])
                }
                onChange={dates => {
                  setStartDate(dates[0].clone().set('hour', 0))
                  setEndDate(
                    dates[1]
                      .clone()
                      .add(1, 'd')
                      .set('hour', 0)
                      .subtract(1, 'h')
                  )
                }}
              />

              <Button onClick={showExplanation} type="primary">
                Show Explanation
              </Button>
            </div>
            <div
              style={{
                display: 'grid',
                // padding: '20px',
                gridTemplateColumns: '1fr',
                // gridGap: '5px 30px',
                // justifyContent: 'space-arround',
                backgroundColor: '#eee',
                gridTemplateRows:
                  'min-content min-content min-content min-content min-content',
                padding: '10px',
              }}
            >
              <div style={{ display: 'grid', justifyContent: 'center' }}>
                <b>MW Chart</b>
              </div>

              <Checkbox
                checked={showTarget}
                onChange={e => setShowTarget(e.target.checked)}
                style={{ marginTop: '10px' }}
              >
                Target
              </Checkbox>
              <div style={{ maxHeight: '20px' }}>
                <svg height="20px" width="100%">
                  <path
                    stroke="rgb(153, 26, 56)"
                    d="M5 10 l215 0"
                    strokeDasharray="5,5"
                    // stroke-linecap="square"
                    strokeWidth="6"
                  />
                </svg>
              </div>

              <Checkbox
                checked={showGenMW}
                onChange={e => setShowGenMW(e.target.checked)}
                style={{ marginTop: '10px' }}
              >
                Actual
              </Checkbox>
              <div
                style={{
                  backgroundColor: 'rgb(177, 93, 200)',
                  // backgroundColor:'rgb(128, 0, 128)',
                  alignSelf: 'center',
                  padding: '5px',
                }}
              />
            </div>
            {/* <div style={{ backgroundColor: 'rgb(216, 248, 220)' }} />
        <Checkbox
          checked={showMaxEco}
          onChange={e => setShowMaxEco(e.target.checked)}
        >
          Max Eco
        </Checkbox>
        <div style={{ backgroundColor: 'rgb(216, 248, 220)' }} />
        <Checkbox
          checked={showMinEco}
          onChange={e => setShowMinEco(e.target.checked)}
        >
          Min Eco
        </Checkbox> */}

            <div
              ref={graphDivRef}
              onScroll={e => onScrollDiv(e)}
              style={{
                display: 'grid',
                overflow: 'scroll',
                maxWidth: width - 150,
              }}
            >
              <HourlyDetailsGraph
                cref={graphSvgRef}
                data={data}
                dateHeaders={dateHeaders}
                columnWidth={columnWidth}
                xScale={xScale}
                // width={width - 200}
              />
            </div>
            <HourlyDetailsData
              cref={gridDataRef}
              data={data}
              date={startDate}
              endDate={endDate}
              width={width}
              graphDivRef={graphDivRef}
              height={height - 200}
              trueup={trueup}
            />
          </div>
        )}
      </FullHeightSizer>
    </Modal>
  )
}

const mapStateToProps = state => ({
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  CLIENT: getClientInfo(state),
})
export default connect(mapStateToProps)(HourlyDetailsModal)
